export var normal_frag_params = "\nvarying vec3 vNormal;\n";